import {
  getWorkspaceValueChainImportance,
  listAssets,
  listValueChainStages,
  type Asset,
  type ValueChainStage,
} from "@/lib/assets";
import { getResults, type AssetHazardResult } from "@/lib/results";

export interface ReportSources {
  assets: Asset[];
  stages: ValueChainStage[];
  stageImportance: Record<string, number>;
  results: AssetHazardResult[];
}

/** The same sources Tab 3 loads, minus asset types (the report doesn't use them). */
export async function loadReportSources(): Promise<ReportSources> {
  const [assetsRes, stagesRes, importanceRes, resultsRes] = await Promise.all([
    listAssets(),
    listValueChainStages(),
    getWorkspaceValueChainImportance(),
    getResults(),
  ]);

  const stageImportance: Record<string, number> = {};
  for (const rating of importanceRes.ratings) stageImportance[rating.valueChainStageId] = rating.importance;

  return { assets: assetsRes.assets, stages: stagesRes.stages, stageImportance, results: resultsRes.results };
}
